import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NavMobileComponent } from './nav-mobile.component';

const routes: Routes = [{ path: '', component: NavMobileComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NavMobileRoutingModule { }
